//  ----------      START   IMPORT  BLOCK       ----------
//  API
import APIService from '../Core/APIService';
//  Config
import API_ROUTES from '../../ConfigFiles/Routes/api_routes';
//  ----------      END   IMPORT  BLOCK       ----------

export default class RegisterService extends APIService {
  // Suggestion: Take a single data object for clarity instead of 6 arguments
  async register(registrationData) { 
    const route = API_ROUTES.register;
    return this.post(route, registrationData);
  }

  async register_professional(dataToSend) {
    const route = API_ROUTES.register_professional;
    return this.post(route, dataToSend);
  }

  async checkUsername(username) {
    const route = API_ROUTES.check_username(username);
    return this.post(route);
  }

}